<div class="wg-meta-panel">

  @if (!loaded) {
    <div class="wg-meta-rows" style="padding: 20px 0;">
      <div class="wg-meta-row">
        <span class="wg-meta-label wg-meta-placeholder">Nalaganje metapodatkov...</span>
      </div>
    </div>
  } @else {

  <!-- IDENTIFIKACIJA -->
  <div class="wg-meta-section">
    <div class="wg-meta-section-title text-primary">IDENTIFIKACIJA</div>
    <div class="wg-meta-rows">
      @for (item of identification; track item.label) {
        <div class="wg-meta-row">
          <span class="wg-meta-label">{{ item.label }}</span>
          @if (item.status === 'active') {
            <span class="wg-meta-value wg-meta-status-active">
              <span class="wg-meta-status-dot"></span> {{ item.value }}
            </span>
          } @else {
            <span class="wg-meta-value">{{ item.value }}</span>
          }
        </div>
      }
      <!--
        Klasifikacijski znak. Absent only when the classification tables are not installed or
        the lookup failed; a record with no stamp still renders, reading 'ni razvrščeno'.
      -->
      @if (classification) {
        <div class="wg-meta-row">
          <span class="wg-meta-label">{{ classification.label }}</span>
          <span class="wg-meta-value">{{ classification.value }}</span>
        </div>
      }
    </div>
  </div>

  <!-- LASTNIK -->
  @if (owner.length > 0) {
  <div class="wg-meta-section wg-meta-section--bordered">
    <button class="wg-meta-section-header" (click)="toggleSection('lastnik')">
      <span class="wg-meta-chevron" [class.wg-meta-chevron--open]="isExpanded('lastnik')">
        <span class="material-symbols-outlined">chevron_right</span>
      </span>
      <span class="material-symbols-outlined wg-meta-section-icon">person</span>
      <span class="wg-meta-section-title">LASTNIK</span>
    </button>
    @if (isExpanded('lastnik')) {
      <div class="wg-meta-rows">
        @for (item of owner; track item.label) {
          <div class="wg-meta-row">
            <span class="wg-meta-label">{{ item.label }}</span>
            <span class="wg-meta-value">{{ item.value }}</span>
          </div>
        }
      </div>
    }
  </div>
  }

  <!-- DATUMI -->
  @if (dates.length > 0) {
  <div class="wg-meta-section wg-meta-section--bordered">
    <button class="wg-meta-section-header" (click)="toggleSection('datumi')">
      <span class="wg-meta-chevron" [class.wg-meta-chevron--open]="isExpanded('datumi')">
        <span class="material-symbols-outlined">chevron_right</span>
      </span>
      <span class="material-symbols-outlined wg-meta-section-icon">calendar_today</span>
      <span class="wg-meta-section-title">DATUMI</span>
    </button>
    @if (isExpanded('datumi')) {
      <div class="wg-meta-rows">
        @for (item of dates; track item.label) {
          <div class="wg-meta-row">
            <span class="wg-meta-label">{{ item.label }}</span>
            <span class="wg-meta-value">{{ item.value }}</span>
          </div>
        }
      </div>
    }
  </div>
  }

  <!-- DNEVNIK SPREMEMB -->
  <div class="wg-meta-section wg-meta-section--bordered">
    <button class="wg-meta-section-header" (click)="toggleSection('dnevnik')">
      <span class="wg-meta-chevron" [class.wg-meta-chevron--open]="isExpanded('dnevnik')">
        <span class="material-symbols-outlined">chevron_right</span>
      </span>
      <span class="material-symbols-outlined wg-meta-section-icon">schedule</span>
      <span class="wg-meta-section-title">DNEVNIK SPREMEMB</span>
      @if (changeLog.length > 0) {
        <span class="wg-meta-badge">{{ changeLog.length }}</span>
      }
    </button>
    @if (isExpanded('dnevnik')) {
      @if (changeLog.length > 0) {
        <div class="wg-meta-timeline">
          @for (entry of changeLog; track entry.date; let last = $last) {
            <div class="wg-meta-timeline-entry">
              <div class="wg-meta-timeline-rail">
                <span class="wg-meta-timeline-dot" [style.background]="entry.color"></span>
                @if (!last) {
                  <span class="wg-meta-timeline-line"></span>
                }
              </div>
              <div class="wg-meta-timeline-content" [class.wg-meta-timeline-clickable]="entry.changes.length > 0 || entry.collectionChanges.length > 0" (click)="toggleEntry(entry)">
                <span class="wg-meta-timeline-date">{{ entry.date }}</span>
                <span class="wg-meta-timeline-desc">
                  {{ entry.description }}
                  @if (entry.changes.length > 0 || entry.collectionChanges.length > 0) {
                    <span class="material-symbols-outlined wg-meta-expand-icon" [class.wg-meta-expand-icon--open]="entry.expanded">expand_more</span>
                  }
                </span>
                <span class="wg-meta-timeline-user">{{ entry.user }}</span>

                <!-- Expanded: field-level changes -->
                @if (entry.expanded) {
                  <div class="wg-meta-changes">
                    @for (change of entry.changes; track change.label) {
                      <div class="wg-meta-change-item">
                        <span class="wg-meta-change-label">{{ change.label }}</span>
                        @if (change.kind === 'added') {
                          <span class="wg-meta-change-added">{{ change.newValue }}</span>
                        } @else if (change.kind === 'removed') {
                          <span class="wg-meta-change-removed">{{ change.oldValue }}</span>
                        } @else {
                          <span class="wg-meta-change-old">{{ change.oldValue }}</span>
                          <span class="wg-meta-change-arrow">&rarr;</span>
                          <span class="wg-meta-change-new">{{ change.newValue }}</span>
                        }
                      </div>
                    }
                    @for (col of entry.collectionChanges; track col.label) {
                      <div class="wg-meta-change-collection">
                        <span class="wg-meta-change-label">{{ col.label }} ({{ col.oldCount }} &rarr; {{ col.newCount }})</span>
                        @for (item of col.items; track item.summary) {
                          <div class="wg-meta-change-collection-item" [title]="item.title || item.summary">
                            @if (item.type === 'added') {
                              <span class="wg-meta-change-added">+ {{ item.summary }}</span>
                            } @else if (item.type === 'removed') {
                              <span class="wg-meta-change-removed">- {{ item.summary }}</span>
                            } @else {
                              <span class="wg-meta-change-modified">~ {{ item.summary }}</span>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="wg-meta-rows">
          <div class="wg-meta-row">
            <span class="wg-meta-label wg-meta-placeholder">Ni zapisov v dnevniku sprememb</span>
          </div>
        </div>
      }
    }
  </div>

  <!-- DOVOLJENJA -->
  <div class="wg-meta-section wg-meta-section--bordered">
    <button class="wg-meta-section-header" (click)="toggleSection('dovoljenja')">
      <span class="wg-meta-chevron" [class.wg-meta-chevron--open]="isExpanded('dovoljenja')">
        <span class="material-symbols-outlined">chevron_right</span>
      </span>
      <span class="material-symbols-outlined wg-meta-section-icon">lock</span>
      <span class="wg-meta-section-title">DOVOLJENJA</span>
    </button>
    @if (isExpanded('dovoljenja')) {
      <div class="wg-meta-rows">
        <div class="wg-meta-row">
          <span class="wg-meta-label wg-meta-placeholder">Podatki o dovoljenjih niso na voljo</span>
        </div>
      </div>
    }
  </div>

  }

</div>
